import React from 'react';
import CollectionIcon from 'assets/icons/icon-collection.svg';
import classNames from 'classnames';
import Button from 'elements/Button';

type Props = {
  onClick: () => void;
  className?: string;
};

const LeftButton: React.FC<Props> = ({ onClick, className }) => {
  return (
    <div className={styles.container(className)}>
      <Button
        type="button"
        variant="ghost"
        color="neutral"
        noAnimation
        aria-controls="mobile-menu"
        aria-expanded="false"
        onClick={onClick}
        className={`${styles.btn.container} min-h-0`}
      >
        <CollectionIcon width={24} height={24} className={styles.btn.icon} />
      </Button>
    </div>
  );
};

export default LeftButton;

const styles = {
  container: (className: string) => classNames('flex items-center', className),
  btn: {
    // Matches the header/sidebar's blue (bg-mf-blue-800 in Header.tsx and
    // ActivityRail.tsx) so the button reads as part of that chrome.
    container: classNames(
      'inline-flex items-center justify-center p-1.5 rounded-full',
      'bg-mf-blue-800 hover:bg-mf-blue-700 active:bg-mf-blue-900',
      'transition-colors duration-200',
    ),
    icon: 'text-white',
  },
};
